// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Graph Engine API
 * HTTP API for managing Neo4j graph engines.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ModelsGraphEngineStatus } from './ModelsGraphEngineStatus';
import {
  ModelsGraphEngineStatusFromJSON,
  ModelsGraphEngineStatusToJSON,
} from './ModelsGraphEngineStatus';
import type { ModelsProvider } from './ModelsProvider';
import { ModelsProviderFromJSON, ModelsProviderToJSON } from './ModelsProvider';

/**
 *
 * @export
 * @interface HandlersGraphEngineInternalResponse
 */
export interface HandlersGraphEngineInternalResponse {
  /**
   *
   * @type {ModelsProvider}
   * @memberof HandlersGraphEngineInternalResponse
   */
  cloudProvider?: ModelsProvider;
  /**
   *
   * @type {string}
   * @memberof HandlersGraphEngineInternalResponse
   */
  configMapName?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersGraphEngineInternalResponse
   */
  createdAt?: string;
  /**
   *
   * @type {object}
   * @memberof HandlersGraphEngineInternalResponse
   */
  dataModel?: object;
  /**
   *
   * @type {string}
   * @memberof HandlersGraphEngineInternalResponse
   */
  dataSourceId?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersGraphEngineInternalResponse
   */
  dataSourceType?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersGraphEngineInternalResponse
   */
  deletedAt?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersGraphEngineInternalResponse
   */
  id?: string;
  /**
   *
   * @type {number}
   * @memberof HandlersGraphEngineInternalResponse
   */
  maximumBytesBilled?: number;
  /**
   *
   * @type {string}
   * @memberof HandlersGraphEngineInternalResponse
   */
  memory?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersGraphEngineInternalResponse
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersGraphEngineInternalResponse
   */
  neo4jVersion?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersGraphEngineInternalResponse
   */
  orchestra?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersGraphEngineInternalResponse
   */
  projectId?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersGraphEngineInternalResponse
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersGraphEngineInternalResponse
   */
  schemaRevision?: string;
  /**
   *
   * @type {ModelsGraphEngineStatus}
   * @memberof HandlersGraphEngineInternalResponse
   */
  status?: ModelsGraphEngineStatus;
}

/**
 * Check if a given object implements the HandlersGraphEngineInternalResponse interface.
 */
export function instanceOfHandlersGraphEngineInternalResponse(
  value: object,
): value is HandlersGraphEngineInternalResponse {
  return true;
}

export function HandlersGraphEngineInternalResponseFromJSON(
  json: any,
): HandlersGraphEngineInternalResponse {
  return HandlersGraphEngineInternalResponseFromJSONTyped(json, false);
}

export function HandlersGraphEngineInternalResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlersGraphEngineInternalResponse {
  if (json == null) {
    return json;
  }
  return {
    cloudProvider:
      json['cloudProvider'] == null
        ? undefined
        : ModelsProviderFromJSON(json['cloudProvider']),
    configMapName:
      json['configMapName'] == null ? undefined : json['configMapName'],
    createdAt: json['createdAt'] == null ? undefined : json['createdAt'],
    dataModel: json['dataModel'] == null ? undefined : json['dataModel'],
    dataSourceId:
      json['dataSourceId'] == null ? undefined : json['dataSourceId'],
    dataSourceType:
      json['dataSourceType'] == null ? undefined : json['dataSourceType'],
    deletedAt: json['deletedAt'] == null ? undefined : json['deletedAt'],
    id: json['id'] == null ? undefined : json['id'],
    maximumBytesBilled:
      json['maximumBytesBilled'] == null
        ? undefined
        : json['maximumBytesBilled'],
    memory: json['memory'] == null ? undefined : json['memory'],
    name: json['name'] == null ? undefined : json['name'],
    namespace: json['namespace'] == null ? undefined : json['namespace'],
    neo4jVersion:
      json['neo4jVersion'] == null ? undefined : json['neo4jVersion'],
    orchestra: json['orchestra'] == null ? undefined : json['orchestra'],
    projectId: json['projectId'] == null ? undefined : json['projectId'],
    region: json['region'] == null ? undefined : json['region'],
    schemaRevision:
      json['schemaRevision'] == null ? undefined : json['schemaRevision'],
    status:
      json['status'] == null
        ? undefined
        : ModelsGraphEngineStatusFromJSON(json['status']),
  };
}

export function HandlersGraphEngineInternalResponseToJSON(
  json: any,
): HandlersGraphEngineInternalResponse {
  return HandlersGraphEngineInternalResponseToJSONTyped(json, false);
}

export function HandlersGraphEngineInternalResponseToJSONTyped(
  value?: HandlersGraphEngineInternalResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloudProvider: ModelsProviderToJSON(value['cloudProvider']),
    configMapName: value['configMapName'],
    createdAt: value['createdAt'],
    dataModel: value['dataModel'],
    dataSourceId: value['dataSourceId'],
    dataSourceType: value['dataSourceType'],
    deletedAt: value['deletedAt'],
    id: value['id'],
    maximumBytesBilled: value['maximumBytesBilled'],
    memory: value['memory'],
    name: value['name'],
    namespace: value['namespace'],
    neo4jVersion: value['neo4jVersion'],
    orchestra: value['orchestra'],
    projectId: value['projectId'],
    region: value['region'],
    schemaRevision: value['schemaRevision'],
    status: ModelsGraphEngineStatusToJSON(value['status']),
  };
}
